<template>
  <div class="author-block bg-gray padding_medium">
    <wpImage
      v-if="user && user.avatar_image"
      :data="user.avatar_image"
      size="medium"
      class="author-image"
      lazy
      background
      placeholder
    />
    <div v-else class="author-image dummy"><span></span></div>
    <div class="author-meta">
      <div class="desc">Skrevet av</div>
      <div class="name" v-if="user && user.name">{{ user.name }}</div>
      <!-- <div class="name dummy" v-else></div> -->
      <div class="date" v-if="date">{{ date }}</div>
    </div>
  </div>
</template>

<script>
import WpImage from "@/components/elements/WpImage";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "author-block",
  props: { 
    id: Number,
    date: String
  },
  data() {
    return {
      //user: null
    };
  },
  computed: {
    ...mapGetters(["getAuthorByID"]),
    user() {
      if (this.id) return this.getAuthorByID(this.id);
      return false;
    }
  },
  mounted() {
    if (this.id && !this.getAuthorByID(this.id)) {
      this.getAuthor(this.id);
    }
  },
  methods: {
    ...mapActions(["getAuthor"])
  },
  components: {
    WpImage
  }
};
</script>

<style lang="scss">
@import "./../../assets/scss/mixins.scss";
@import "./../../assets/scss/vars.scss";

.author-block {
  display: flex;
  align-items: center;
  margin-bottom: 50px;
  .author-image {
    margin: 0;
    padding: 0;
    width: 71px;
    height: 71px;
    border-radius: 71px;
    overflow: hidden;
    &.dummy {
      @extend %preloadBgLight;
      position: relative;
      span {
        position: absolute;
        width: 30px;
        height: 30px;
        border-radius: 30px;
        background: #a0a0a0;
        left: 50%;
        top: 20px;
        transform: translateX(-50%);
      }
      &:after {
        content: "";
        position: absolute;
        width: 45px;
        height: 45px;
        border-radius: 45px;
        background: #a0a0a0;
        bottom: -20px;
        transform: translateX(-50%);
        left: 50%;
      }
    }
  }
  .author-meta {
    margin-left: 20px;
    .desc {
      font-size: 14px;
      font-style: italic;
    }
    .name {
      font-size: 16px;
      font-weight: 700;
      margin-top: 5px;
      &.dummy {
        @extend %preloadBgLight;
        height: 15px;
        width: 120px;
      }
    }
    .date {
      font-size: 14px;
      color: #666;
      margin-top: 5px;
    }
  }
}
</style>
